<script setup lang="ts">
import CommonBtn from '../common-btn/CommonBtn.vue'
import { House, Aim, Box, User, Message, Help } from '@element-plus/icons-vue'
import { useCommonStore } from '@/stores/modules/common'
import { computed } from 'vue'

const commonStore = useCommonStore()

const footerBarData = [
  {
    icon: House,
    name: '主城',
    path: 'Home',
  },
  {
    icon: Aim,
    name: '共斗',
    path: 'Fight',
  },
  {
    icon: Help,
    name: '副本',
    path: 'Dungeon',
  },
  {
    icon: Box,
    name: '背包',
    path: 'Item',
  },
]

const mailLength = computed(() => commonStore.mailList.filter((item) => !item.isGet).length)
</script>

<template>
  <div class="footer-bar-wrap">
    <div class="footer-bar">
      <div class="item" v-for="item of footerBarData" :key="item.name">
        <CommonBtn :plain="item.path !== commonStore.path" @done="commonStore.path = item.path">
          <el-icon size="24px">
            <component :is="item.icon"></component>
          </el-icon>
          <span>{{ item.name }}</span>
        </CommonBtn>
      </div>
      <div class="item">
        <el-badge :value="mailLength" :hidden="!Boolean(mailLength)" :offset="[-15, 0]" :max="50">
          <CommonBtn :plain="'Mail' !== commonStore.path" @done="commonStore.path = 'Mail'">
            <el-icon size="24px">
              <component :is="Message"></component>
            </el-icon>
            <span>邮件</span>
          </CommonBtn>
        </el-badge>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.footer-bar-wrap {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 1000;
  .footer-bar {
    display: flex;
    max-width: $maxWidth;
    margin: 0 auto;
    justify-content: space-between;
    background-color: var(--backColor);
    .item {
      width: 20%;
      text-align: center;
      span {
        font-size: 16px;
        margin-left: 0;
      }
    }
  }
}
</style>
